import React from 'react';
import styled from 'styled-components';
import { BackButtonContainer, Button, Link } from '../buttons';
import { Icon } from '../icon';
import { Steps } from '../steps';

const PageHeaderWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: sticky;
    top: ${(props) => (props.theme.additionalProperties?.isStitchMode || props.theme.additionalProperties?.isToolbarHidden ? '0px' : '54px')};
    z-index: 2;
    padding-bottom: 24px;
    align-items: flex-start;
    gap: 10px;
    background-color: ${(props) => props.theme.app.backgroundColor};

    ${(props) => props.theme.additionalProperties?.isStitchMode && `padding: 10px;`}
    ${(props) => props.theme.additionalProperties?.isStitchMode && `margin-bottom: 10px;`}
`;

const PageHeaderBackSteps = styled.div`
    display: flex;
    flex: 1 0 100%;
    padding: 10px 0px;

    ${Button} {
        margin-left: 10px;
    }
    ${BackButtonContainer} {
        padding: 0;
        text-transform: none;
        ${Icon} {
            margin-right: 2px;
            margin-left: -7px;
        }
    }
`;
const PageHeaderSteps = styled.div`
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    padding-top: 3px;
    min-height: 26px;
`;
const PageHeaderTitleDescription = styled.div`
    flex: 1 0;
    color: ${(props) => props.theme.app.textColor};
`;
const PageHeaderTitle = styled.h2`
    margin: 0 !important;
    font-size: ${(props) => props.theme.app.component.pageHeader.title.size};
    font-weight: ${(props) => props.theme.app.component.pageHeader.title.weight};
    font-family: ${(props) => props.theme.app.font};
    line-height: ${(props) => props.theme.app.component.pageHeader.lineHeight};
`;

const PageHeaderDescription = styled.div<{ $hasDescription: boolean }>`
    padding-block-start: 8px;
    line-height: ${(props) => props.theme.app.component.pageHeader.lineHeight};

    > a {
        margin-left: ${(props) => (props.$hasDescription ? '4px' : '0')} !important;
    }
`;

const PageHeaderLearnMore = styled(Link)`
    margin-left: 0 !important;
    display: inline-block;
`;

export const PageHeaderButtons = styled.div`
    position: sticky;
    top: ${(props) => (props.theme.additionalProperties?.isStitchMode || props.theme.additionalProperties?.isToolbarHidden ? `0px` : '55px')};
    z-index: 17;
    background-color: #f6f8f9;
    margin: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    ${Button} {
        margin-left: 10px;
    }

    ${BackButtonContainer} {
        margin-right: auto;
    }
`;
export const BackAndSteps = styled(PageHeaderButtons)`
    max-width: ${(props) => props.theme.size.container};
    padding: 0 20px 0px 20px;

    ${Steps} {
        width: 100%;
    }
`;

export const FullPageHeaderButtons = styled(PageHeaderButtons)`
    max-width: 100%;
`;

export const PageHeaderButtonsWrap = styled.div`
    display: flex;
    gap: 10px;
    margin-inline-start: auto;

    ${Button} {
        padding: 10px 16px;
        border: 1px solid;
        line-height: 16px;
    }
`;

PageHeaderContainer.BackSteps = PageHeaderBackSteps;
PageHeaderContainer.Steps = PageHeaderSteps;
PageHeaderContainer.TitleDescription = PageHeaderTitleDescription;
PageHeaderContainer.Title = PageHeaderTitle;
PageHeaderContainer.Description = PageHeaderDescription;
PageHeaderContainer.LearnMore = PageHeaderLearnMore;
PageHeaderContainer.Buttons = PageHeaderButtonsWrap;

export function PageHeaderContainer({ children, className }: { children?: React.ReactNode; className?: string }) {
    return <PageHeaderWrap className={className}>{children}</PageHeaderWrap>;
}
